import React from "react";
import PropTypes from "prop-types";
import {
  Wrapper,
  Header,
  MinMaxValues,
  RangeValues,
  Animation,
} from "../SliderComponents";
import { RangeSlider, LogEvent } from "@learningblocks/shared-components";

import "./style.scss";

export function SliderWeb(props) {
  return (
    <Wrapper
      className="slider_container"
      tabIndex={0}
      ariaLabel={props.animeAriaLabel}
    >
      <Header className="slider_container_heading" text={props.animationText} />
      <figure className="fullWidthAnimation">
        <Animation
          className="slider_container_animation"
          frame={props.value}
          animation={props.animation}
        />
        <figcaption
          style={{ display: props.animationCaption ? "initial" : "none" }}
        >
          {props.animationCaption}
        </figcaption>
      </figure>
      <Wrapper className="slider_container_sliderblock">
        <Header
          className="slider_container_sliderblock_title"
          text={props.sliderText}
        />
        <LogEvent
          logEventProps={{
            event_type: "sim_sliderwidget_value updated",
            event_schema: "slider",
            slider_value: props.value,
          }}
          actionProps={{ onChange: { action: "change" } }}
          elementType="div"
        >
          <RangeSlider
            value={props.value}
            onChange={props.onChange}
            step={props.step}
            min={props.min}
            max={props.max}
            ariaLabel={props.sliderAriaLabel}
          />
        </LogEvent>
        {props.displayRange ? (
          <RangeValues
            className="sliderWeb_minmax"
            range={props.displayRange}
          />
        ) : (
          <MinMaxValues
            className="sliderWeb_minmax"
            min={props.displayMin}
            max={props.displayMax}
          />
        )}
      </Wrapper>
    </Wrapper>
  );
}

SliderWeb.propTypes = {
  /**
   *text above animation
   */
  animationText: PropTypes.string,
  /**
   * Slider text
   */
  sliderText: PropTypes.string,
  /**
   * Current value of slider
   */
  value: PropTypes.number,
  /**
   * function to invoke on rangeSlider onChange
   */
  onChange: PropTypes.func,
  /**
   * lower limit of slider
   */
  min: PropTypes.number,
  /**
   * upper limit for slider
   */
  max: PropTypes.number,
  /**
   * range values for slider
   */
  displayRange: PropTypes.array,
  /**
   * bool value to show submit button
   */
  showSubmit: PropTypes.bool,
  /**
   * aria label for animation
   */
  animeAriaLabel: PropTypes.string,
  /**
   * aria label for range slider
   */
  sliderAriaLabel: PropTypes.string,
  /**
   * specifies how much units is one step for rangeSlider
   */
  step: PropTypes.number,
};

SliderWeb.defaultProps = {
  animationText: "Drag the slider thumb to see the changes of []",
  sliderText: "Temperature",
  showSubmit: false,
  min: 0,
  max: 100,
  step: 1,
};
